module.exports = __webpack_public_path__ + "assets/img/EXCLUSIVE_GATEWAY_PLUGIN.4b2d0297.svg";